export function attachListeners(viewer, virtualTourPlugin, vtv) {
    virtualTourPlugin.addEventListener("node-changed", chain(viewer, virtualTourPlugin));
    virtualTourPlugin.addEventListener("node-changed", switchTour(vtv));
}
function chain(viewer, virtualTourPlugin) {
    return (e) => {
        // don't chain if not coming from link
        if (!e.data.fromLink)
            return;
        const fromNode = e.data.fromNode;
        if (!fromNode)
            return;
        const chains = e.node.data?.chains;
        if (!chains)
            return;
        const toNodeId = chains[Number(fromNode.id)]?.to;
        if (!toNodeId)
            return;
        const link = e.node.links?.find(l => l.nodeId === toNodeId.toString());
        if (!link)
            return;
        // gotoLink() not used to be able to cancel the chain by interupting the animation
        viewer.animate({
            ...virtualTourPlugin.getLinkPosition(toNodeId.toString()),
            speed: "10rpm",
        }).then(complete => {
            if (complete) {
                virtualTourPlugin.setCurrentNode(toNodeId.toString(), {}, link);
            }
        });
    };
}
function switchTour(vtv) {
    return (e) => {
        const loadTour = e.data.fromLink?.data?.loadTour;
        if (!loadTour)
            return;
        e.stopImmediatePropagation();
        vtv.switchTour(loadTour);
    };
}
